import React from 'react';

import { Button } from '@eika/button';
import { InfoCard } from '@eika/card';
import { IconTypes } from '@eika/icon';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import useTranslation from '../../hooks/useTranslation';

type Props = {
    show: boolean;
    isFilter: boolean;
    goToSearch: () => void;
};

const TransacitionListNoMoreContent: React.FC<Props> = ({ show, isFilter, goToSearch }) => {
    const translated = useTranslation();
    if (!show) return null;
    if (isFilter)
        return (
            <div className="container">
                <InfoCard skipBackground className="transaction-list__no-more-content-card">
                    <RichIcon type={RichIconTypes.FANGER_SOMMERFUGLER} />
                    <InfoCard.TitleH3>{translated.transactionFilter.noMoreToLoad}</InfoCard.TitleH3>
                    <div className="transaction-list__no-more-content-card__content-wrapper">
                        <p className="transaction-list__no-more-content-card__description">
                            {translated.transactionFilter.didYouNotFindWhatYouWereLookingFor}
                        </p>
                        <div className="transaction-list__no-more-content-card__submit-wrapper">
                            <Button onClick={goToSearch} iconOnRightSide icon={IconTypes.SOEK_24}>
                                {translated.transactionFilter.backToSearch}
                            </Button>
                            <Button buttonType="negative" onClick={() => window.scroll({ top: 0, behavior: 'smooth' })}>
                                {translated.transactionFilter.toTheTop}
                            </Button>
                        </div>
                    </div>
                </InfoCard>
            </div>
        );
    return (
        <div className="container">
            <InfoCard skipBackground className="transaction-list__no-more-content-card">
                <RichIcon type={RichIconTypes.SPOKELSE} />
                <InfoCard.TitleH3>{translated.transactionListNoMoreTransactionsToLoadTitle}</InfoCard.TitleH3>
                <div className="transaction-list__no-more-content-card__content-wrapper">
                    <div className="transaction-list__no-more-content-card__submit-wrapper">
                        <Button onClick={goToSearch} iconOnRightSide icon={IconTypes.SOEK_24}>
                            {translated.transactionFilter.goToAdvancedSearch}
                        </Button>
                        <Button buttonType="negative" onClick={() => window.scroll({ top: 0, behavior: 'smooth' })}>
                            {translated.transactionFilter.toTheTop}
                        </Button>
                    </div>
                </div>
            </InfoCard>
        </div>
    );
};

export default TransacitionListNoMoreContent;
